import { Module } from "module";
import React,{Component} from "react";
import Modal from "react-bootstrap/Modal";
import jQuery from "jquery";
import HeaderTabs from "../../../Components/UI/HeaderTabs";
import { callPOST } from "../../../Utils/ApiUtil";




class ImportCertificate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      
      activeCertificateTab: "",
      formField :{
        certificate:'',
        private_key:'',
        key_chain:''
      },
      activePrivateKeyTab: 'pastePrivateKey',
      activeKeychainTab: '',
      certificateTabs: [
        {
          name: "Upload Certificate",
          attributes: {
            "aria-selected": true,
            id: "uploadCertificate",
            className: "nav-link show active",
          },
          clickHandler: this.onUploadTypeChange.bind(
            this,
            "certificate",
            "uploadCertificate"
          ),
        },
        {
          name: "Paste Certificate",
          attributes: {
            "aria-selected": false,
            id: "pasteCertificate",
            className: "nav-link",
          },
          clickHandler: this.onUploadTypeChange.bind(
            this,
            "certificate",
            "pasteCertificate"
          ),
        },
      ],
      privateKeyTabs: [
        {
          name: "Upload Private key",
          attributes: {
            "aria-selected": true,
            id: "uploadPrivateKey",
            className: "nav-link show active",
          },
          clickHandler: this.onUploadTypeChange.bind(this, "private-key", "uploadPrivateKey"),
        },
        {
          name: "Paste Private key",
          attributes: {
            "aria-selected": false,
            id: "pastePrivateKey",
            className: "nav-link",
          },
          clickHandler: this.onUploadTypeChange.bind(this, "private-key", "pastePrivateKey"),
        },
      ],
      keyChainTab: [
        {
          name: "Upload Key-Chain ",
          attributes: {
            "aria-selected": true,
            id: "uploadKeyChain",
            className: "nav-link show active",
          },
          clickHandler: this.onUploadTypeChange.bind(this, "key-chain", "uploadKeyChain"),
        },
        {
          name: "Paste Key-Chain",
          attributes: {
            "aria-selected": false,
            id: "pasteKeyChain",
            className: "nav-link",
          },
          clickHandler: this.onUploadTypeChange.bind(this, "key-chain", "pasteKeyChain"),
        },
      ],
    };
  }




  componentDidMount = () => {
   

  };
  componentDidUpdate = (prevProps) => { 
    console.log('componentDidUpdate',"preprops",prevProps.isModalOpen,"props",this.props.isModalOpen);
    if(prevProps.isModalOpen!==this.props.isModalOpen){
      this.setState({
        formField :{
          certificate:'',
          private_key:'',
          key_chain:''
        }
      })
    }
  };



  valueChangeHandler=(e)=>{
    let name = e.target.name;
    let value = e.target.value;
    console.log('name',name,'value',value);
    // let update = { ...formFieldData[name], value: value, failMessage: "" };
    const updatedFieldValue = {...this.state.formField,[name]:value};
    console.log('update field value',updatedFieldValue);
    this.setState({
      formField: updatedFieldValue,
    });
  }
  onUploadTypeChange = (field, activeTabId) => {
    console.log("onuploadtypeChnage", activeTabId);
    if (field === "certificate") {
      let updatedcertificateTabs = this.state.certificateTabs;
      updatedcertificateTabs.map((tab) => {
        if (tab.attributes.id && tab.attributes.id === activeTabId) {
          tab.attributes.className = "nav-link show active";
        } else {
          tab.attributes.className = "nav-link";
        }
        return tab;
      });
      this.setState({
        activeCertificateTab: activeTabId,
        certificateTabs: [...updatedcertificateTabs],
      });
    } else if (field === "private-key") {
      let updatedKeyTabs = this.state.privateKeyTabs;
      updatedKeyTabs.map((tab) => {
        if (tab.attributes.id && tab.attributes.id === activeTabId) {
          tab.attributes.className = "nav-link show active";
        } else {
          tab.attributes.className = "nav-link";
        }
        return tab;
      });
      this.setState({
        activePrivateKeyTab: activeTabId,
        privateKeyTabs: [...updatedKeyTabs],
      });
    } else if (field === "key-chain") {
      let updateCsrTabs = this.state.keyChainTab;
      updateCsrTabs.map((tab) => {
        if (tab.attributes.id && tab.attributes.id === activeTabId) {
          tab.attributes.className = "nav-link show active";
        } else {
          tab.attributes.className = "nav-link";
        }
        return tab;
      });
      this.setState({ activeKeychainTab: activeTabId, keyChainTab: [...updateCsrTabs] });
    }
  };

  clearCertificate =()=>{
    console.log('clearCertificate')
  }

  valueChange =(name,value)=>{
    console.log('valueChage',name,value)
    const {formField} = this.state;
    this.setState({
      formField:{...formField,[name]:value}
    })
  }



  uploadFileHandler=(e)=>{
    
    console.log('uploadfilehandler',e);
    var file = e.target.files;
    var name = e.target.name;
    console.log('name',name,file[0].type,file[0].size);
    const {formField} =this.state;
    // var textType = /crt.*/;
    var content ;
    var fileReader = new FileReader();
    const this_ = this;
    fileReader.onload = function(e) {
      content = e.target.result;
      console.log('data',content);
      this_.setState({
        formField:{...formField,[name]:content}
      })
    }; 
    fileReader.readAsText(file[0])

  }
  importSaveHandler=()=>{
    console.log('uploading values',this.state.formField);
    const { Loader, succMessage, failMessage,getCertificateList,toggleModel } = this.props;
    const {formField} = this.state
    const formData = new FormData();            
        formData.append("certificate", formField.certificate);
        formData.append("private-key",formField.private_key);
        formData.append("key-chain",formField.key_chain);
    Loader();
    callPOST("domain/certificate/import",formData)
    .then(response=>{
      console.log('response',response);
      const responseData =response.data;
      Loader();
      if(response.status===200){
        if(responseData.code===200){
          succMessage(responseData.message);
          getCertificateList();
          toggleModel('import');
        }else{
          failMessage(responseData.message);
        }
      }
    },(error)=>{
      Loader();
      console.log('error',error);
    })
  }
  render() {

    const { isModalOpen, toggleModel} = this.props;
    const formField =this.state.formField;
    console.log('formField',formField);
    return (
      <>
     <div className={isModalOpen ? "quick_sidebar_open" : ""}>
  <div className=" quick-sidebar p-0">
    <a
      href="#"
      onClick={() => toggleModel("import")}
      className="close-quick-sidebar"
      style={{ top: 0, right: "10px", zIndex: 1 }}
    >
      <i className="fas fa-times fa-lg" />
    </a>
    <div className="view">
      <div className="table_Box dataTables_wrapper">
        <div className="modal-header">
          <h4 className="mb-0"> Import Certificate </h4>
        </div>
        <div className="table_Body">
          <div className="card-body">
            <div className="row">
              <div className="col-12">
                <div className="">
                  {/* <HeaderTabs attributes={{ className: "nav nav-pills navcrm-primary nav-pills-no-bd", role: "tablist", }} headerTabsList={this.state.privateKeyTabs} /> */}
                  <div className="panel-footer text-center">
                    <span className="pull-left">Certificate Body</span>
                    <span className="pull-right">
                      {/* <span ><i className="fas fa-cloud-upload-alt fa-lg text-info pr-2" /></span> */}
                     
                      <input
                        id="certificateUpload"
                        accept=".pem,.crt,.cer,.key,.txt"
                        type="file"
                        name="certificate"
                        hidden
                        onChange={this.uploadFileHandler}
                      />
                      <label htmlFor="certificateUpload" >
                      <i className="fas fa-cloud-upload-alt fa-lg text-info pr-2" > </i>
                      </label>
                     
                     
                    </span>
                    {/* Key Upload */}
                    {/* <div id="uploadPrivateKey" className={ this.state.activePrivateKeyTab === "uploadPrivateKey" ? "d-flex tab-pane fade active show" : "d-none tab-pane fade" } style={{ display: "block" }} >
                          <div className="input-group">
                            <div className="input-group-prepend">
                              <button className="btn border browseCSV">
                                <input type="file" accepts=".pem,.crt,.cer,.key" name="key_chain" onChange={(e) => console.log('certificate update') } />
                                Choose Key-Chain
                              </button>
                            </div>
                            <input type="text" name="filename"  className="form-control"  readOnly />
                          </div>
                          <div className=" pl-2">
                            <span onClick={(e) => console.log('file upload') } className="input-group-text cursor-pointer" > <i className="fas fa-cloud-upload-alt fa-lg text-info pr-2" />{" "} Upload </span>
                          </div>
                        </div> */}
                    {/* Key Paste */}
                    {/* <div id="pastePrivateKey" className={ this.state.activePrivateKeyTab === "pastePrivateKey" ? "d-flex tab-pane fade active show" : "d-none tab-pane fade" } > */}
                    <div>
                      <textarea
                        id="certificateInput"
                        onChange={this.valueChangeHandler}
                        placeholder="Paste certificate body below"
                        name="certificate"
                        value={formField.certificate}
                        style={{ height: "120px" }}
                        className="form-control"
                        maxLength="5000"
                        decimal="0"
                      />
                      <div className="text-center pl-2">
                        {/* <span onClick={(e) => console.log('keychaintextarea upload') } className="input-group-text cursor-pointer" >
                              <i className="fas fa-cloud-upload-alt fa-lg text-info pr-2" />{" "}
                              Upload
                            </span> */}
                      </div>
                    </div>
                  </div>
                  <div className="panel-footer text-center">
                    <span className="pull-left" >Certificate Private Key </span>
                    <span className="pull-right">
                      <input
                        id="privateKeyUpload"
                        accept=".pem,.crt,.cer,.key,.txt"
                        type="file"
                        name="private_key"
                        hidden
                        onChange={this.uploadFileHandler}
                      />
                      <label htmlFor="privateKeyUpload">  <i className="fas fa-cloud-upload-alt fa-lg text-info pr-2" /></label>                    </span>
                    <div>
                      <textarea
                        id="privateKeyInput"
                        onChange={this.valueChangeHandler}
                        name="private_key"
                        placeholder="Paste certificate private key below"
                        style={{ height: "120px" }}
                        value={formField.private_key}
                        className="form-control"
                        maxLength="5000"
                        decimal="0"
                      />
                    </div>
                  </div>

                  <div className="panel-footer text-center">
                    <span className="pull-left">Certificate Key-Chain (Optional)</span>
                    <span className="pull-right">
                      <input
                        id="keyChainUpload"
                        accept=".pem,.crt,.cer,.key,.txt"
                        type="file"
                        name="key_chain"
                        hidden
                        onChange={this.uploadFileHandler}
                      />
                      <label htmlFor="keyChainUpload" >
                      <i className="fas fa-cloud-upload-alt fa-lg text-info pr-2" > </i>
                      </label>  
                    </span>
                    <div>
                      <textarea
                        id="keyChainInput"
                        onChange={this.valueChangeHandler}
                        name="key_chain"
                        placeholder="Paste certificate key-chain below"
                        style={{ height: "120px" }}
                        className="form-control"
                        value={formField.key_chain}
                        maxLength="5000"
                        decimal="0"
                      />
                    </div>
                  </div>
                
                  <div className="text-center pt-3 mx-auto">
                    {/* <button type="button" className="btns btn-border btn-default" onClick={this.clearCertificate} data-dismiss="modal" > Clear</button> */}
                    <button
                      type="button"
                      className="btn primary_bg"
                      onClick={this.importSaveHandler}
                      disabled={
                        this.state.formField.certificate !== "" &&
                        this.state.formField.private_key !== ""
                          ? false
                          : true
                      }
                    >
                      {" "}
                      Upload
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
{
  isModalOpen ? <div className="quick-sidebar-overlay"></div> : ""
}

         </>

      // <Modal size="fullscreen"  show={isModelOpen} onHide={toggleModel}>
      //       <Modal.Header>
      //       <h6 className="mb-0"> Search Certificate
      //                       <div className="btn-right">
      //                           {/* <a className="btn primary_bg cursor-pointer" onClick={this.toggleCreateNewCertificate} >Add New Certificate</a> */}
      //                       </div>
      //                   </h6>
      //       </Modal.Header>
      //       <Modal.Body>
      //       <CreateDomainCertificate
      //                       formFieldData={this.state.formFieldData}
      //                       toggleModel={this.toggleCertificate}
      //                       isCreateNewModelOpen={this.state.isCertificateModelOpen}
      //                       valueChangeHandler={this.certificateValueChangeHandler}
      //                     countryChangeHandler={this.PickListChangeHandler}
      //                     saveHandler={this.saveHandler}
      //                   />   
      //                       <TableRecord
      //                           tableRecords={tableRecords}
      //                           />
      //       </Modal.Body>

      //       <Modal.Footer>
      //        <div className="ml-md-auto py-2 py-md-0">
      //             <a onClick={toggleModel} className="btn btn-border border-default mr-2"> Cancel </a> 
      //             <a onClick={saveHandler} className="btn primary_bg"> Save </a> 
      //         </div>
      //       </Modal.Footer>
      //       </Modal>
    );
  }

}
export default ImportCertificate;


//hi?
